// CSS Modules - component class name prefix: Breadcrumbs__

<template>
  <ol :class="$style.container">
    <li v-for="(crumb, index) in crumbs" :key="index">
      <a :href="crumb.url" target="_top" v-html="crumb.title"></a>
    </li>
  </ol>
</template>

<script>
export default {
  name: "Breadcrumbs",
  props: {
    crumbs: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style module lang="scss">
@import "./Breadcrumbs.scss";
</style>
